/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of GlobalUtil
 */

export default abstract class GlobalUtil {
    /**
     * 当前页面是否加载完成
     * @returns {boolean}
     */
    public static isLoaded(): boolean {
        if (window.performance && window.performance.timing) { // 现代浏览器
            return !!window.performance.timing.loadEventEnd;
        } else { // 老式浏览器
            return window.document.readyState === 'complete';
        }
    }

    /**
     * 是否空字符串
     * @param str{string}
     * @returns {boolean}
     */
    public static isEmptyString(str: string | undefined): boolean {
        if (!str) {
            return false;
        }
        let result = true;
        if (Object.prototype.toString.call(str) !== '[object String]') {
            result = false;
        }
        // \s 小写的s是，匹配任何空白字符，包括空格、制表符、换页符等等。等价于 [ \f\n\r\t\v]。
        if (str.replace(/(^\s*)|(\s*$)/g, '').length === 0) {
            result = false;
        }
        return result;
    }

    /**
     * 设置OMG的日志
     * @param str
     */
    public static dispatchOmgLog(str: string): void {
        const mesageEvent: MessageEvent = document.createEvent('MessageEvent');
        mesageEvent.initMessageEvent('omglog', false, false, str, '', '', window);
        window.dispatchEvent(mesageEvent);
    }

    /**
     * 判断当前应用的 scheme 是否为桌面环境
     * @returns {boolean}
     */
    public static isDesktop(): boolean {
        return window.location && window.location.protocol === 'file:';
    }

    /**
     * 获取当前应使用的 protocol
     * @returns {string}
     */
    public static getProtocol(): string {
        // 20190618 lincal：应安全部要求，全面启用 https 协议
        return 'https://';
        // return GlobalUtil.isDesktop() ? 'https://' : '//';
    }
}
